/** @jsxImportSource theme-ui */

import { Button, ButtonProps } from "theme-ui";

const GoBackButton: React.FunctionComponent<ButtonProps> = ({...props}) => {
  return (
    <Button variant="goBackBtn" aria-label="go back" {...props}>
      <svg
        width="54"
        height="48"
        viewBox="0 0 54 48"
        xmlns="http://www.w3.org/2000/svg"
        sx={{fill:'text'}}
      >
        <path
          d="M50.2938 20.6438H10.7851L22.8776 6.11952C23.443 5.43922 23.7151 4.56217 23.6338 3.6813C23.5526 2.80043 23.1248 1.9879 22.4445 1.42246C21.7642 0.857017 20.8872 0.584981 20.0063 0.666196C19.1254 0.747411 18.3129 1.17522 17.7475 1.85552L1.0912 21.843C0.979139 22.002 0.87893 22.169 0.791387 22.3427C0.791387 22.5093 0.791388 22.6092 0.5582 22.7758C0.407206 23.1577 0.328147 23.5643 0.325012 23.975C0.328147 24.3857 0.407206 24.7923 0.5582 25.1743C0.5582 25.3408 0.558199 25.4408 0.791387 25.6073C0.87893 25.781 0.979139 25.948 1.0912 26.107L17.7475 46.0945C18.0607 46.4706 18.4529 46.773 18.8962 46.9802C19.3396 47.1875 19.8231 47.2946 20.3125 47.2938C21.0909 47.2953 21.8452 47.0242 22.4445 46.5276C22.7818 46.2479 23.0607 45.9045 23.265 45.5169C23.4694 45.1293 23.5953 44.7052 23.6356 44.2689C23.6758 43.8326 23.6295 43.3926 23.4995 42.9742C23.3694 42.5558 23.1581 42.1671 22.8776 41.8305L10.7851 27.3063H50.2938C51.1773 27.3063 52.0246 26.9553 52.6493 26.3306C53.2741 25.7058 53.625 24.8585 53.625 23.975C53.625 23.0915 53.2741 22.2442 52.6493 21.6195C52.0246 20.9947 51.1773 20.6438 50.2938 20.6438Z"
          
        />
      </svg>
    </Button>
  );
};

export default GoBackButton;
